import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';
import { postArchiveDataEndpoint } from '../../../common/endpoints';

export const postUndoArchive = createApi(postArchiveDataEndpoint, 'POST');

const UndoArchive = createSlice({
  name: 'UndoArchive',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(postUndoArchive.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(postUndoArchive.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(postUndoArchive.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default UndoArchive.reducer;